/**
 * @generated SignedSource<<c61cb9a94972bfef99232b6c8ca7449c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type libraryImportTaskQueriesListQuery$variables = {
  state?: number | null;
};
export type libraryImportTaskQueriesListQuery$data = {
  readonly libraryImportTasks: ReadonlyArray<{
    readonly createdOn: string;
    readonly displayMessage: string;
    readonly errorCount: number;
    readonly importedImages: number;
    readonly lastError: string;
    readonly modifiedOn: string | null;
    readonly progressPercent: number;
    readonly startedOn: string | null;
    readonly state: number;
    readonly stateName: string;
    readonly target: number;
    readonly taskID: number;
    readonly totalImages: number | null;
  }>;
};
export type libraryImportTaskQueriesListQuery = {
  response: libraryImportTaskQueriesListQuery$data;
  variables: libraryImportTaskQueriesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "state"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      }
    ],
    "concreteType": "LibraryImportTask",
    "kind": "LinkedField",
    "name": "libraryImportTasks",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "target",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stateName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "importedImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "progressPercent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastError",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startedOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedOn",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "libraryImportTaskQueriesListQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "libraryImportTaskQueriesListQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "0d2f4411125e622bf2b5d20e6d417677",
    "id": null,
    "metadata": {},
    "name": "libraryImportTaskQueriesListQuery",
    "operationKind": "query",
    "text": "query libraryImportTaskQueriesListQuery(\n  $state: Int\n) {\n  libraryImportTasks(state: $state) {\n    taskID\n    target\n    state\n    stateName\n    totalImages\n    importedImages\n    progressPercent\n    errorCount\n    lastError\n    displayMessage\n    createdOn\n    startedOn\n    modifiedOn\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6611a0b0749a2b42aed4bfe7225d90a";

export default node;
